import { CurrencyCode } from "~/graphql/mainEnums";

export const usdDollarsToMoney = (dollars: number | null) =>
  dollars == null
    ? null
    : {
        amount: Math.round(dollars * 100),
        currency: CurrencyCode.Usd,
        precision: 2,
      };
